export const RESEND_EMAIL_ATTEMPT = 'RESEND_EMAIL_ATTEMPT';
export const RESEND_EMAIL_SUCCESS = 'RESEND_EMAIL_SUCCESS';
export const RESEND_EMAIL_FAILURE = 'RESEND_EMAIL_FAILURE';

export const RESEND_EMAIL_CLEAR = 'RESEND_EMAIL_CLEAR';
export const CLEAR_STATE = 'CLEAR_STATE';
